/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DomainData } from './DomainData';
import {
    DomainDataFromJSON,
    DomainDataFromJSONTyped,
    DomainDataToJSON,
    DomainDataToJSONTyped,
} from './DomainData';

/**
 * 
 * @export
 * @interface TurnoverByDomain
 */
export interface TurnoverByDomain {
    /**
     * 
     * @type {Array<DomainData>}
     * @memberof TurnoverByDomain
     */
    dataByDomain?: Array<DomainData>;
}

/**
 * Check if a given object implements the TurnoverByDomain interface.
 */
export function instanceOfTurnoverByDomain(value: object): value is TurnoverByDomain {
    return true;
}

export function TurnoverByDomainFromJSON(json: any): TurnoverByDomain {
    return TurnoverByDomainFromJSONTyped(json, false);
}

export function TurnoverByDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): TurnoverByDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'dataByDomain': json['dataByDomain'] == null ? undefined : ((json['dataByDomain'] as Array<any>).map(DomainDataFromJSON)),
    };
}

export function TurnoverByDomainToJSON(json: any): TurnoverByDomain {
    return TurnoverByDomainToJSONTyped(json, false);
}

export function TurnoverByDomainToJSONTyped(value?: TurnoverByDomain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataByDomain': value['dataByDomain'] == null ? undefined : ((value['dataByDomain'] as Array<any>).map(DomainDataToJSON)),
    };
}

